import React, { useRef, useEffect, useState } from "react";
import ButtonPrimary from "components/Button/ButtonPrimary";
import Input from "components/Input/Input";
import Label from "components/Label/Label";
import SocialsList from "components/SocialsList/SocialsList";
import Textarea from "components/Textarea/Textarea";
import Heading2 from "components/Heading/Heading2";
import Layout from "../layout";
import axios from "axios";
import "../../../styles/styles.css"

const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const info = [
  {
    title: "💌 COURRIEL",
    desc: "ahuncycle@gmail.com"
  },
  {
    title: "☎ TÉLÉPHONE",
    desc: "438-777-3100",
  },
];

const PageContact = () => {
   const [errors, setErrors] = useState({} as any);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [response, setResponse] = useState('');

   const handleSubmit = async (e: any) => {
    e.preventDefault();

    const newErrors:any = [];

    console.log(name);
    if (name=="") {
      newErrors.name = "Le nom d'utilisateur est requis.";
    } 
    if (email=="") {
      newErrors.email = "L'adresse email est requise.";
    }
    else if (!/^\S+@\S+\.\S+$/.test(email)) {
      newErrors.email = "L'adresse email est invalide.";
    }
    if (message=="") {
      newErrors.message = "Le message est requis.";
    } 
    setErrors(newErrors);
    console.log("erreurs:",newErrors);
    if (newErrors.length===0) 
    {
      console.log("Form submitted:", email);
    
      try 
      {
        const form = new FormData();
        form.append('name', name);
        form.append('email', email);
        form.append('message', message);
        const response = await axiosInstance.post("api/mail",form);
        console.log("Form data submitted successfully:", response.data);
        alert("Message envoyé avec succès!");
        window.location.href = window.location.origin;
      } 
      catch (error) 
      {
        console.error("Erreur d'envoie du message:", error);
      }
    }
  }
  return ( 
    <>
<div style={{width:"80%",backgroundColor:"whitesmoke",color:"black"}} className="p-5 mx-auto bg-white rounded-xl sm:rounded-3xl lg:rounded-[40px] shadow-lg dark:bg-neutral-900">
      
  <div className="container">
      <header className="text-center max-w-2xl mx-auto  sm:mb-16 lg:mb-8 ">
        <Heading2 className="center inline-block align-middle text-4xl font-semibold md:text-5xl">Contact</Heading2>
        <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
          Laissez un message et nous vous recontacterons.
        </span>
      </header>
      <div className="grid gap-8 lg:grid-cols-2">
        <div className="max-w-sm space-y-6">
          {info.map((item, index) => (
            <div key={index}>
              <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                {item.title}
              </h3>
              <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                {item.desc}
              </span>
            </div>
          ))}
          <div>
            <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
              🌏 RÉSEAUX
            </h3>
            <SocialsList className="mt-2" />
          </div>
        </div>
        <div className="border border-neutral-100 dark:border-neutral-700 lg:hidden"></div>
        <div>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-3"  method="POST">
            <label className="block">
              <Label>Nom</Label>
              <Input 
                placeholder="" 
                type="text" 
                className="mt-1" 
                value={name} 
                onChange={(e) => setName(e.target.value)} 
              />
            </label>
            {errors.name != "" && (
              <span style={{ color: "red", marginLeft: "5px" }}>{errors.name}</span>
            )}
            <label className="block">
              <Label>Courriel</Label>
              <Input
                type="email"
                placeholder="exemple@exemple.com"
                className="mt-1"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            {errors.email && (
              <span style={{ color: "red", marginLeft: "5px" }}>{errors.email}</span>
            )}
            <label className="block">
              <Label>Message</Label>
              <Textarea 
                className="mt-1" 
                rows={2} 
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </label>
            {errors.message && (
              <span style={{ color: "red", marginLeft: "5px" }}>{errors.message}</span>
            )}
            <ButtonPrimary type="submit">Envoyer</ButtonPrimary>
          </form>
          {response && <p>{response}</p>}
        </div>
      </div>
      </div>
      <br></br> 
      </div>
    <br></br>
    </>
  );
};

export default PageContact;
